import { useTranslation } from '@frontend/i18n';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { useContentComposer } from '../../content-composer/content-composer-provider';
import { ToolboxButton } from '../../content-composer/toolbox-atoms/toolbox-button';
import { TextSection } from './text-section';

export const TextTool = () => {
  const { t } = useTranslation('content-composer');
  const { insertSection } = useContentComposer();

  return (
    <ToolboxButton
      icon='template'
      title={t('Text')}
      subtitle={t('Insert header or body text.')}
      onClick={() => insertSection(<TextSection />)}
      trackingId={`${BulkEmailPrefixes.Composer}-text-tool-btn`}
    >
      <TextSection />
    </ToolboxButton>
  );
};
